export const TEXTS = {
  PROFILE_CHANGE_PASSWORD_BUTTON: 'Сменить пароль',
  PROFILE_CHANGE_PASSWORD_CURRENT: 'Текущий пароль',
  PROFILE_CHANGE_PASSWORD_NEW: 'Новый пароль',
  PROFILE_CHANGE_PASSWORD_SUCCESS: 'Пароль изменён',
  PROFILE_LOGOUT_BUTTON: 'Выйти из аккаунта',
};
